// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutHeader-EmptyResultTypography_cls1__mU5KQ","cls2":"PayoutHeader-EmptyResultTypography_cls2__Ln8Nb PayoutHeader-EmptyResultTypography_cls1__mU5KQ"};